var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: "social-media-group-popup" + (_vm.isEdit ? " is-edit" : "") },
    [
      _vm.allActiveUsers.length
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-7" },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.hideTitle,
                        expression: "!hideTitle"
                      }
                    ],
                    staticClass: "group-title"
                  },
                  [
                    _c(
                      "h1",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.editTitle,
                            expression: "!editTitle"
                          }
                        ],
                        staticClass:
                          "mb-0 exclude-outside-click edit-d-title project-title",
                        on: { click: _vm.activateTitleField }
                      },
                      [_vm._v(_vm._s(_vm.socialCampaignDetail.title))]
                    ),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editTitle,
                          expression: "editTitle"
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.socialCampaignDetail.title,
                          expression: "socialCampaignDetail.title"
                        },
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.clickOutsideTitle,
                          expression: "clickOutsideTitle"
                        }
                      ],
                      ref: "editTitleRef",
                      staticClass:
                        "form-control mb-3 title-field exclude-outside-click h1",
                      attrs: {
                        type: "text",
                        placeholder: "Social Media Campaign..."
                      },
                      domProps: { value: _vm.socialCampaignDetail.title },
                      on: {
                        change: function($event) {
                          return _vm.updateSocialCampaign()
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.socialCampaignDetail,
                            "title",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "campaign-date" }, [
                  _c("div", { staticClass: "start-date field-box" }, [
                    _c("div", [
                      _c("span", { staticClass: "date-label" }, [
                        _vm._v("Start Date")
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "editable-campaign-date" },
                        [
                          _c("div", {
                            staticClass: "custom-field-outside-bg-mobile"
                          }),
                          _vm._v(" "),
                          _c(
                            "vuejs-datepicker",
                            {
                              ref: "startDatePicker",
                              attrs: { placeholder: "No Date" },
                              on: {
                                input: function($event) {
                                  return _vm.updateSocialCampaign()
                                }
                              },
                              model: {
                                value: _vm.socialCampaignDetail.start_date,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.socialCampaignDetail,
                                    "start_date",
                                    $$v
                                  )
                                },
                                expression: "socialCampaignDetail.start_date"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "calender-header",
                                  attrs: { slot: "beforeCalendarHeader" },
                                  slot: "beforeCalendarHeader"
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "remove-dl-btn",
                                      attrs: { variant: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onRemoveDate("startDate")
                                        }
                                      }
                                    },
                                    [_vm._v("Remove Date")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "today-btn",
                                      attrs: { variant: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onToday("startDate")
                                        }
                                      }
                                    },
                                    [_vm._v("Today")]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "end-date field-box" }, [
                    _c("div", [
                      _c("span", { staticClass: "date-label" }, [
                        _vm._v("End Date ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "editable-campaign-date" },
                        [
                          _c("div", {
                            staticClass: "custom-field-outside-bg-mobile"
                          }),
                          _vm._v(" "),
                          _c(
                            "vuejs-datepicker",
                            {
                              ref: "endDatePicker",
                              attrs: { placeholder: "No Date" },
                              on: {
                                input: function($event) {
                                  return _vm.updateSocialCampaign()
                                }
                              },
                              model: {
                                value: _vm.socialCampaignDetail.end_date,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.socialCampaignDetail,
                                    "end_date",
                                    $$v
                                  )
                                },
                                expression: "socialCampaignDetail.end_date"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "calender-header",
                                  attrs: { slot: "beforeCalendarHeader" },
                                  slot: "beforeCalendarHeader"
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "remove-dl-btn",
                                      attrs: { variant: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onRemoveDate("endDate")
                                        }
                                      }
                                    },
                                    [_vm._v("Remove Date")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "today-btn",
                                      attrs: { variant: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onToday("endDate")
                                        }
                                      }
                                    },
                                    [_vm._v("Today")]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.socialCampaignDetail.customFields, {
                    field_key: "social_campaign_detail"
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      { staticClass: "field-box social-campaign-detail-field" },
                      [
                        _c("CustomFields", {
                          key: "scfields" + _vm.socialCampaignDetail.id,
                          attrs: {
                            detail: _vm.socialCampaignDetail,
                            customField: field,
                            showLabel: false
                          }
                        })
                      ],
                      1
                    )
                  }
                )
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-5 campaign-details" },
              [
                typeof _vm.socialCampaignDetail == "object"
                  ? _c(
                      "div",
                      { staticClass: "field-box" },
                      [
                        _c("CustomFields", {
                          key: "scfields" + _vm.socialCampaignDetail.id,
                          attrs: {
                            detail: _vm.socialCampaignDetail,
                            customField: {
                              field_key: "engagement_manager",
                              field_name: "engagement_manager",
                              label: "Engagement Manager"
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                typeof _vm.socialCampaignDetail == "object"
                  ? _c(
                      "div",
                      { staticClass: "field-box" },
                      [
                        _c("CustomFields", {
                          key: "scfields" + _vm.socialCampaignDetail.id,
                          attrs: {
                            detail: _vm.socialCampaignDetail,
                            customField: {
                              field_key: "project_lead",
                              field_name: "project_lead",
                              label: "Project Lead"
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.socialCampaignDetail.customFields, function(
                    o
                  ) {
                    // Hardcoded
                    return (
                      ![20, 21, 22, 33, 37].includes(o.field_id) &&
                      o.field_key != "social_campaign_detail" &&
                      o.field_key != "social_campaign_coordinator"
                    )
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      {
                        key: "sc_field_" + Math.random(),
                        staticClass: "field-box"
                      },
                      [
                        _c("CustomFields", {
                          key: "scfields" + _vm.socialCampaignDetail.id,
                          attrs: {
                            detail: _vm.socialCampaignDetail,
                            customField: field
                          }
                        })
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _c("div", { staticClass: "project--resources" }, [
                  _c(
                    "div",
                    { staticClass: "dropdown project--resources--title" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "add-resource-button exclude-outside-click d-inline-block",
                          attrs: {
                            title: "Add resource",
                            id: "add-resource-button",
                            "data-toggle": "dropdown",
                            "aria-expanded": "false"
                          }
                        },
                        [_vm._v("Resources")]
                      ),
                      _vm._v(" "),
                      _c("plus-button", {
                        attrs: {
                          "data-toggle": "dropdown",
                          "aria-expanded": "false",
                          "data-reference": "parent"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "dropdown-menu project--resources--type--menu"
                        },
                        _vm._l(_vm.optionsForLinkType, function(type, i) {
                          return _c(
                            "a",
                            {
                              key: i,
                              staticClass: "dropdown-item",
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  return _vm.addResourceMenuItemClick(
                                    type.id,
                                    $event
                                  )
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "link-type-icon",
                                attrs: {
                                  src: require("@/csmworkflow/img/" + type.icon)
                                }
                              }),
                              _vm._v(" " + _vm._s(type.name))
                            ]
                          )
                        }),
                        0
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "project--resources--content" },
                    _vm._l(
                      _vm._.filter(_vm.socialCampaignDetail.customFields, {
                        field_key: "link_url"
                      }),
                      function(resource, index) {
                        return _vm.showResourceBox(
                          resource.value,
                          resource.scfv_id
                        )
                          ? _c(
                              "div",
                              {
                                key: "link_url-" + index,
                                staticClass: "resource-entry",
                                class: _vm.userCanEditSocialCampaign
                                  ? "editable"
                                  : "not-editable"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "resource-box__url" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: resource.value,
                                          target: "blank",
                                          id:
                                            "social-campaign-resource-" + index
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.openCopyLinkModal(
                                              resource.value,
                                              $event,
                                              index
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.customChildFieldValue(
                                              "link_label",
                                              resource.scfv_id
                                            ) || resource.value
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tooltip",
                                      {
                                        attrs: {
                                          target:
                                            "social-campaign-resource-" + index,
                                          noninteractive: "",
                                          triggers: "manual"
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-check",
                                          staticStyle: { color: "#4C9850" }
                                        }),
                                        _vm._v(" Link Copied!")
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.userCanEditSocialCampaign
                                  ? _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true }
                                          }
                                        ],
                                        staticClass: "edit-resource-btn",
                                        attrs: {
                                          title: "Edit resource",
                                          href: "#"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.editResource(resource)
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fas fa-edit" })]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "link-type-icon",
                                  attrs: {
                                    src: require("@/csmworkflow/img/" +
                                      _vm.getLinkTypeObject(
                                        _vm.customChildFieldValue(
                                          "link_type",
                                          resource.scfv_id
                                        )
                                      ).icon),
                                    draggable: "false"
                                  }
                                }),
                                _vm._v(" "),
                                _vm.customChildFieldValue(
                                  "link_notes",
                                  resource.scfv_id
                                )
                                  ? _c(
                                      "div",
                                      { staticClass: "resource-box__notes" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.customChildFieldValue(
                                              "link_notes",
                                              resource.scfv_id
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      }
                    ),
                    0
                  )
                ])
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "createSocialCampaignLinkModal",
            title: "New Resource / Link"
          },
          on: { shown: _vm.focusLinkModal }
        },
        [
          _c("CreateLinkModal", {
            ref: "refLinkModal",
            attrs: {
              "link-url": _vm.linkUrl,
              "link-label": _vm.linkLabel,
              "link-notes": _vm.linkNotes,
              "link-type": _vm.linkType
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            id: "editLinkModal",
            title: "Update Resource / Link"
          },
          on: { shown: _vm.focusEditLinkModal }
        },
        [
          _c("EditLinkModal", {
            ref: "refEditLinkModal",
            attrs: {
              "link-url": _vm.linkUrl,
              "link-label": _vm.linkLabel,
              "link-notes": _vm.linkNotes,
              "link-type": _vm.linkType,
              "is-file": _vm.editLinkIsFile
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            id: "linkCopyLinkModal",
            title: "Copy Link",
            "ok-only": "",
            "ok-title": "Done"
          }
        },
        [
          _c("LinkCopyLinkModal", {
            attrs: { linkUrl: _vm.linkCopyModalValue }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "responsive-edit-modal-controls" }, [
        _vm.userAbilities.deleteSocialCampaign &&
        !_vm.socialCampaignDetail.permissions.viewOnly &&
        !_vm.hideDelete
          ? _c(
              "button",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover",
                    modifiers: { hover: true }
                  }
                ],
                staticClass: "btn delete-deliverable-btn",
                attrs: {
                  title: "Delete Campaign: " + _vm.socialCampaignDetail.title
                },
                on: {
                  click: function($event) {
                    return _vm.removeSocialCampaign()
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-trash-alt" })]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: { ok: _vm.onConfirmRemoveSocialCampaign },
          model: {
            value: _vm.showRemoveSocialCampaign,
            callback: function($$v) {
              _vm.showRemoveSocialCampaign = $$v
            },
            expression: "showRemoveSocialCampaign"
          }
        },
        [
          _c("p", [
            _vm._v("Are you sure you want to delete this social campaign?")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }